import type { Messages } from "../types";

export const ro = {
  "common": {
    "brand": "UN8",
    "brandTag": "Dating creștin exclusiv",
    "continue": "Continuă",
    "leave": "Pleacă",
    "leaveForNow": "Pleacă deocamdată",
    "yes": "Da",
    "no": "Nu",
    "goBack": "Înapoi",
    "saving": "Se salvează…",
    "submitting": "Se trimite…",
    "pleaseWait": "Te rugăm să aștepți…",
    "ellipsis": "…",
    "male": "Bărbat",
    "female": "Femeie",
    "phases": {
      "gate": "Poartă",
      "verify": "Verificare",
      "setup": "Configurare",
      "profile": "Profil"
    },
    "storageQuota": "Acest telefon nu mai are spațiu pentru răspunsurile salvate. Eliberează spațiu de stocare, apoi încearcă din nou.",
    "storageDisabled": "Acest browser nu va salva răspunsurile tale. Dezactivează modul privat sau permite datele site-ului, apoi reîncarcă.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min. {min} caractere"
  },
  "welcome": {
    "promise": "Scopul nostru este să ștergi această aplicație cât mai repede posibil.",
    "sub": "UN8 îi ajută pe creștinii single serioși să găsească un partener de viață — apoi să plece. Verificat. Valorile întâi. Fără swipe fără sfârșit.",
    "signedInAs": "Autentificat ca {email}",
    "liveServer": " · server live",
    "deviceOnly": " · doar acest dispozitiv",
    "migrateOffer": "Acest dispozitiv încă are un profil local. Îl încarci pe serverul comun ca alte telefoane să te vadă după moderare? Nimic nu se încarcă până nu alegi.",
    "uploadLocalProfile": "Încarcă profilul meu local",
    "keepOnDevice": "Păstrează-l doar pe acest dispozitiv",
    "migrateNeedGender": "Alege mai întâi Bărbat sau Femeie în profilul tău.",
    "migrateDone": "Textul profilului a fost încărcat. Reîncarcă actul de identitate, videoclipul și fotografiile ca moderarea să le poată verifica.",
    "deleteConfirm": "Ștergi definitiv contul, toate mesajele și tot media (inclusiv actul de identitate și videoclipul) de pe server?",
    "accountDeleted": "Cont șters.",
    "begin": "Începe",
    "continueOnboarding": "Continuă onboarding-ul",
    "logIn": "Autentificare",
    "logOut": "Deconectare",
    "reviewConsole": "Consolă de verificare",
    "matching": "Matching",
    "deleteMyAccount": "Șterge-mi contul"
  },
  "faith": {
    "eyebrow": "Poarta credinței",
    "title": "Doar creștini",
    "text": "UN8 este o comunitate de următori ai lui Isus Hristos, pentru membri care caută un partener orientat spre căsătorie care împărtășește acea credință. Această poartă nu poate fi ocolită.",
    "yesTitle": "Sunt creștin",
    "yesBody": "Îl urmez pe Isus Hristos și caut un partener orientat spre căsătorie care împărtășește această credință.",
    "noTitle": "Nu sunt creștin",
    "noBody": "UN8 nu este locul potrivit pentru mine — și e în regulă.",
    "respectTitle": "Cu respect",
    "respectBody": "UN8 este construit pentru o singură comunitate și preferăm să fim onești decât să-ți pierdem timpul. Folosește Pleacă mai jos sau Înapoi dacă aici nu e casa ta.",
    "sharedTitle": "Temelie comună",
    "sharedBody": "Credința nu e o etichetă aici. Este terenul pe care vă întâlniți.",
    "hintNotChristian": "UN8 este pentru următori ai lui Isus Hristos. Atinge Pleacă mai jos sau alege opțiunea creștină dacă tu ești acela.",
    "hintUnset": "Atinge „Sunt creștin” pentru a continua sau Pleacă / Înapoi dacă aici nu e casa ta."
  },
  "rules": {
    "eyebrow": "Legământul comunității",
    "title": "Cum ne tratăm unii pe alții",
    "text": "Afirmă fiecare regulă. Toate trei sunt obligatorii. Încălcările duc la eliminare permanentă. Profilurile false sunt interzise pe viață.",
    "agreeContinue": "Sunt de acord — continuă",
    "respectful": {
      "title": "Fii respectuos",
      "description": "Vorbește și acționează cu demnitate. Fiecare persoană de aici este făcută după chipul lui Dumnezeu."
    },
    "noSexualContent": {
      "title": "Fără conținut sexual",
      "description": "Fără fotografii, mesaje sau cereri explicite. Puritatea nu e opțională aici."
    },
    "noDominance": {
      "title": "Nu domina și nu controla",
      "description": "Fără constrângere, manipulare sau presiune. Dragostea nu controlează."
    },
    "hint": "Bifează toate cele trei promisiuni înainte să continui."
  },
  "intent": {
    "eyebrow": "",
    "title": "Ce cauți?",
    "text": "",
    "marriage": {
      "label": "Un partener de viață",
      "description": ""
    },
    "discernment": {
      "label": "Distingere serioasă",
      "description": ""
    },
    "notCasual": {
      "label": "Nimic întâmplător",
      "description": ""
    },
    "hint": "Alege una."
  },
  "account": {
    "eyebrow": "Cont",
    "title": "Creează-ți accesul",
    "text": "Handle-ul tău creează un user id stabil. Cererea, verificarea, like-urile și match-urile se leagă de acel id. Nu se trimite niciun email.",
    "recoveryTitle": "Salvează codul de recuperare",
    "recoveryText": "Afișat o singură dată. Fără el, o parolă pierdută nu poate fi resetată în acest test închis.",
    "savedContinue": "L-am salvat — continuă",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com sau un handle scurt",
    "passphrase": "Parolă",
    "passphrasePlaceholder": "Cel puțin 8 caractere",
    "signedInTitle": "Autentificat",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Standard de încredere",
    "trustBody": "Niciun profil nu e vizibil până când verificarea identității e completă și moderarea te aprobă.",
    "continueToVerification": "Continuă la verificare",
    "hintEmail": "Tastează o adresă de email care include @.",
    "hintPassword": "Alege o parolă de cel puțin 8 caractere."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verificare",
      "title": "Încrederea este poarta",
      "text": "Încarcă un act de identitate oficial, un videoclip de confirmare și {min}–{max} fotografii reale. Totul intră într-o coadă de verificare înainte ca profilul tău să poată apărea.",
      "whyTitle": "De ce verificăm",
      "whyBody": "Catfishing-ul și jumătățile de adevăr nu au loc aici. Profilurile false sunt interzise definitiv. Media se stochează cu status pending_review până la aprobare.",
      "start": "Începe verificarea"
    },
    "steps": {
      "id": {
        "title": "Act de identitate oficial",
        "description": "Pașaport sau carte de identitate națională — cameră sau încărcare fișier."
      },
      "video": {
        "title": "Videoclip de confirmare",
        "description": "O înregistrare scurtă care dovedește că ești prezent."
      },
      "photos": {
        "title": "Fotografii reale",
        "description": "Șapte până la zece fotografii clare cu tine."
      },
      "review": {
        "title": "Verificare de integritate",
        "description": "Încărcările rămân pending_review până când personalul confirmă."
      }
    },
    "id": {
      "eyebrow": "Pasul 1 din 4",
      "title": "Act de identitate oficial",
      "text": "Capturează sau încarcă pașaportul sau cartea de identitate națională. Nimic nu e postat public — statusul rămâne pending_review până când personalul confirmă.",
      "savedTitle": "Actul de identitate salvat",
      "savedBody": "Urmează un videoclip scurt de confirmare al feței tale, apoi 7 până la 10 fotografii reale cu tine. Continuă se deblochează când acest act arată salvat.",
      "hint": "Fă sau încarcă o fotografie a actului de identitate oficial, apoi așteaptă până scrie salvat."
    },
    "video": {
      "eyebrow": "Pasul 2 din 4",
      "title": "Videoclip de confirmare",
      "text": "Înregistrează un clip scurt sau încarcă unul. Privește camera. Vorbește clar. Asta dovedește că ești prezent — nu o galerie extrasă.",
      "hint": "Înregistrează un videoclip scurt de confirmare, apoi așteaptă până scrie salvat."
    },
    "photos": {
      "eyebrow": "Pasul 3 din 4",
      "title": "Fotografii reale",
      "text": "Adaugă {min}–10 fotografii recente cu tine. Folosește camera sau biblioteca. Atinge × pentru a elimina orice cadru.",
      "continueToReview": "Continuă la verificare",
      "hint": "Adaugă {min} până la 10 fotografii clare cu tine. Continuă se deblochează când sunt salvate."
    },
    "review": {
      "eyebrow": "Pasul 4 din 4",
      "title": "Verificare de integritate",
      "text": "Media e în coadă ca pending_review{underUser}. Match-urile și like-urile vor folosi același id.",
      "underUser": " sub utilizatorul {userId}",
      "governmentId": "Act de identitate oficial",
      "confirmationVideo": "Videoclip de confirmare",
      "photos": "Fotografii",
      "missing": "Lipsește",
      "filesReady": "{count} fișiere gata",
      "submittedTitle": "Trimis spre verificare",
      "submittedText": "Application id este egal cu auth user id ca approve → pool și like-urile reciproce să rămână aliniate.",
      "submitContinue": "Trimite și continuă"
    }
  },
  "setup": {
    "eyebrow": "Configurare cont",
    "title": "Spune adevărul despre tine",
    "text": "Aceste răspunsuri modelează matching-ul și apar la verificare. Minciunile moi pierd timpul tuturor — inclusiv al tău.",
    "beginSetup": "Începe configurarea",
    "pillars": {
      "faith": {
        "name": "Credință",
        "text": "De ce îl urmezi pe Hristos."
      },
      "character": {
        "name": "Caracter",
        "text": "Loialitate, onestitate, pasiune, angajament — evaluate 1–10."
      },
      "story": {
        "name": "Poveste",
        "text": "Cine ești și ce cauți."
      },
      "life": {
        "name": "Viață",
        "text": "Hobby-uri, lectură și vocație."
      }
    },
    "whyChristian": {
      "eyebrow": "Credință",
      "title": "De ce ești creștin?",
      "text": "Un răspuns scurt, onest. Nu o predică — un motiv care e al tău.",
      "label": "Răspunsul tău",
      "placeholder": "ex. L-am întâlnit pe Hristos într-un sezon de pierdere și Îl urmez de atunci…",
      "hint": "Scrie cel puțin {min} caractere despre de ce îl urmezi pe Isus."
    }
  },
  "scales": {
    "eyebrow": "Scale de caracter",
    "title": "Evaluează-te onest",
    "text": "Loialitate, onestitate, pasiune, angajament — fiecare de la 1 la 10. Umflarea numerelor te potrivește greșit mai târziu. Trebuie să setezi fiecare scală pentru a continua.",
    "loyalty": {
      "label": "Nivel de loialitate",
      "hint": "Fii onest — cât de fidel stai alături de cei pe care îi iubești?"
    },
    "honesty": {
      "label": "Nivel de onestitate",
      "hint": "Cât de consecvent spui tot adevărul?"
    },
    "passion": {
      "label": "Cât de pasionat ești?",
      "hint": "Convingere și adâncime — nu performanță."
    },
    "commitment": {
      "label": "Nivel de angajament",
      "hint": "Cât de gata ești să construiești ceva care durează?"
    },
    "hint": "Mișcă fiecare glisor ca să apară un număr — niciunul să nu rămână ca o liniuță."
  },
  "about": {
    "eyebrow": "Despre tine",
    "title": "Descrie-te în câteva propoziții",
    "text": "Cine ești când nimeni nu joacă un rol. Temperament, ritm, ce contează zi de zi.",
    "label": "Despre tine",
    "placeholder": "Dimineți liniștite, serios cu familia, râd ușor, prefer adâncimea în locul zgomotului…",
    "hint": "Scrie cel puțin {min} caractere despre tine."
  },
  "looking": {
    "eyebrow": "Partener",
    "title": "Ce cauți?",
    "text": "Principalele trăsături de caracter pe care le dorești la un potențial partener — nu o listă de cumpărături de aspect.",
    "label": "Trăsături de caracter dorite",
    "placeholder": "ex. Credință statornică, maturitate emoțională, bunătate sub stres…",
    "hint": "Scrie cel puțin {min} caractere despre partenerul pe care îl speri."
  },
  "loveReady": {
    "eyebrow": "Prag",
    "title": "Ești gata să întâlnești dragostea vieții tale?",
    "text": "UN8 există ca single-ii serioși să găsească un partener — apoi să șteargă aplicația. Doar „Da” deblochează continuarea.",
    "yesTitle": "Da — sunt gata",
    "yesBody": "Sunt aici să-mi întâlnesc persoana cu claritate și curaj.",
    "noTitle": "Nu încă",
    "noBody": "Dacă doar răsfoiești, această comunitate nu e potrivită.",
    "comeBackTitle": "Revino când ești gata",
    "comeBackBody": "UN8 e pentru oameni pregătiți să se întâlnească — nu să adune opțiuni. Folosește Pleacă mai jos dacă vrei să te oprești deocamdată. Răspunsurile tale sunt salvate pe acest telefon.",
    "hintNo": "Doar „Da” continuă. Dacă nu ești gata, atinge Pleacă deocamdată — răspunsurile tale rămân pe acest telefon.",
    "hintUnset": "Atinge Da dacă ești gata să întâlnești pe cineva pentru căsătorie."
  },
  "lifestyle": {
    "eyebrow": "Stil de viață",
    "title": "Cum trăiești zi de zi",
    "text": "Sport, hobby-uri, lectură și profesie — semnale practice pentru compatibilitate reală.",
    "hobbies": "Sporturi sau hobby-uri actuale",
    "hobbiesPlaceholder": "Ce faci activ — nu ce făceai odată.",
    "reading": "Citești?",
    "readingHint": "1 = aproape niciodată · 10 = zilnic, lectură profundă",
    "profession": "Profesie / sector",
    "professionPlaceholder": "ex. Nursing · Software · Educație · Meserii",
    "hintHobbies": "Numește cel puțin un sport sau hobby pe care îl faci cu adevărat.",
    "hintReading": "Glisează „Citești?” ca să apară un număr de la 1 la 10.",
    "hintProfession": "Tastează munca pe care o faci, chiar și un cuvânt scurt."
  },
  "faithDepth": {
    "eyebrow": "Matching · Credință",
    "title": "Cât de centrală e credința ta?",
    "text": "Slujirea lui Dumnezeu — cât de importantă în viața ta? Răspunde onest. Matching-ul folosește asta pentru adâncime, nu pentru performanță.",
    "serving": "Slujirea lui Dumnezeu — importanță",
    "servingHint": "10% … 100%. Glisează în pași de 10.",
    "keepsCommandments": "Păzești poruncile?",
    "grewUpInChurch": "Ai crescut în biserică?",
    "churchAttendance": "Prezența la biserică",
    "frequent": {
      "label": "Frecvent",
      "hint": "Adunare regulată cu trupul lui Hristos."
    },
    "seldom": {
      "label": "Rareori",
      "hint": "Ocazional, nu un ritm săptămânal."
    },
    "never": {
      "label": "Niciodată",
      "hint": "Nu participi în prezent."
    },
    "spreadsGospel": "Răspândești evanghelia?",
    "hasIdols": "Ai idoli?",
    "hintServing": "Glisează cât de importantă e slujirea lui Dumnezeu în viața ta.",
    "hintCommandments": "Răspunde dacă păzești poruncile — Da sau Nu.",
    "hintGrewUp": "Răspunde dacă ai crescut în biserică — Da sau Nu.",
    "hintAttendance": "Alege cât de des mergi la biserică.",
    "hintGospel": "Răspunde dacă împărtășești evanghelia — Da sau Nu.",
    "hintIdols": "Răspunde dacă ai idoli — Da sau Nu."
  },
  "character": {
    "eyebrow": "Matching · Caracter",
    "title": "Cine ești acasă",
    "text": "Caracter pentru curtare — pace, maniere, onestitate. Umflarea răspunsurilor te potrivește greșit mai târziu.",
    "peacemaker": "Ești un făcător de pace?",
    "homebuilder": "Ești un ziditor de casă?",
    "humorous": "Ești plin de umor?",
    "caring": "Grijuliu și afectuos?",
    "peacefulHome": "Vrei o casă pașnică — fără certuri?",
    "manners": "Bune maniere?",
    "honestyRating": "Evaluarea onestității pe acest chestionar",
    "honestyHint": "1–10 — cât de onest răspunzi?",
    "hintPeacemaker": "Răspunde la fiecare Da sau Nu, începând cu făcătorul de pace.",
    "hintHomebuilder": "Răspunde dacă ești un ziditor de casă.",
    "hintHumorous": "Răspunde dacă ești plin de umor.",
    "hintCaring": "Răspunde dacă ești grijuliu și afectuos.",
    "hintPeaceful": "Răspunde dacă vrei o casă pașnică.",
    "hintManners": "Răspunde dacă ai bune maniere.",
    "hintHonesty": "Glisează evaluarea onestității de la 1 la 10."
  },
  "history": {
    "eyebrow": "Matching · Istoric",
    "title": "Trecut și pregătire",
    "text": "Substanțe, copilărie, cicatrici și dacă ești gata pentru o relație de durată. Adevărul aici vă protejează pe amândoi.",
    "marijuana": "Ai folosit marijuana?",
    "lsd": "Ai folosit LSD?",
    "otherDrugs": "Ai folosit alte droguri?",
    "addicted": "Ai fost dependent?",
    "childhood": "Copilărie stabilă, plină de iubire?",
    "scars": "Cicatrici / rănit?",
    "lasting": "Gata pentru o relație de durată?",
    "hintStart": "Răspunde la fiecare Da sau Nu pe această pagină, începând de sus.",
    "hintLsd": "Răspunde la întrebarea despre LSD — Da sau Nu.",
    "hintOtherDrugs": "Răspunde dacă ai folosit alte droguri.",
    "hintAddicted": "Răspunde dacă ai fost dependent.",
    "hintChildhood": "Răspunde dacă copilăria ta a fost stabilă și plină de iubire.",
    "hintScars": "Răspunde dacă porți cicatrici.",
    "hintLasting": "Răspunde dacă ești gata pentru o relație de durată."
  },
  "appearance": {
    "eyebrow": "Matching · Aspect",
    "title": "Tatuaje",
    "text": "Tatuajele tale și dacă tatuajele pe un partener sunt acceptabile pentru tine.",
    "hasTattoos": "Ai tatuaje?",
    "acceptsPartner": "Accepți tatuaje pe un partener?",
    "hintHas": "Spune dacă ai tatuaje — Da sau Nu.",
    "hintAccepts": "Spune dacă tatuajele pe un partener sunt acceptabile pentru tine."
  },
  "home": {
    "eyebrow": "Matching · Casă & pământ",
    "title": "Pământ, abilități, autosuficiență",
    "text": "Ierburi, cultivarea hranei, pădure de fructe, pregătire, agricultură comunitară, conservare, supraviețuire — și abilități speciale.",
    "herbKnowledge": "Cunoștințe despre ierburi?",
    "plantOwn": "Plantezi propriile fructe și legume?",
    "fruitForest": "Interesat de o pădure de fructe?",
    "prepping": "Pregătire pentru calamități?",
    "communityFarming": "Agricultură comunitară / viață independentă?",
    "canning": "Conserve și conservare?",
    "survival": "Abilități de supraviețuire?",
    "specialSkills": "Abilități speciale (opțional)",
    "specialPlaceholder": "Orice altceva aduci unei gospodării sau unui pământ…",
    "hintStart": "Răspunde la fiecare Da sau Nu despre pământ și abilități, începând de sus.",
    "hintPlant": "Răspunde dacă plantezi propriile fructe și legume.",
    "hintFruitForest": "Răspunde dacă te interesează o pădure de fructe.",
    "hintPrepping": "Răspunde dacă te pregătești pentru calamități.",
    "hintCommunity": "Răspunde dacă te interesează agricultura comunitară.",
    "hintCanning": "Răspunde dacă faci conserve și conservezi mâncarea.",
    "hintSurvival": "Răspunde dacă ai abilități de supraviețuire."
  },
  "family": {
    "eyebrow": "Matching · Familie",
    "title": "Copii, adâncimea credinței, substanțe",
    "text": "Ce ai nevoie la un partener privind intensitatea credinței, copiii și consumul trecut de substanțe.",
    "children": "Copii",
    "wants": {
      "label": "Vrea copii",
      "hint": "Construirea unei familii face parte din viziune."
    },
    "doesNotWant": {
      "label": "Nu vrea copii",
      "hint": "Nu clar pe copii."
    },
    "open": {
      "label": "Deschis",
      "hint": "Discerne — nu e blocat nici într-o parte, nici în cealaltă."
    },
    "hasLivingWith": {
      "label": "Are copii — locuiește cu ei",
      "hint": "Copiii sunt deja parte din viața de zi cu zi."
    },
    "requiredFaith": "Nivelul minim de credință de care ai nevoie la un partener",
    "requiredFaithHint": "10% … 100%. Poartă dură când ambele părți au răspuns.",
    "acceptsSubstances": "Accepți consumul trecut de substanțe la un partener?",
    "hintChildren": "Alege o carte despre copii.",
    "hintFaith": "Glisează nivelul minim de credință pe care îl speri la un partener.",
    "hintSubstances": "Spune dacă consumul trecut de substanțe la un partener este acceptabil."
  },
  "ancestry": {
    "eyebrow": "Matching · Fundal",
    "title": "Preferințe de fundal",
    "text": "Împărtășește fundalul tău și la ce ești deschis la un partener. Asta modelează doar clasamentul — nu ascunde pe nimeni din pachet.",
    "yourBackground": "Fundalul tău (selectează tot ce se aplică)",
    "openToPartner": "Deschis la un partener",
    "codeDesc": "Cod: {code}",
    "anyDesc": "Cea mai puternică preferință pentru amplitudine — recomandat când ești nesigur.",
    "preferenceOnly": "Doar preferință — nu o poartă.",
    "hintOwn": "Bifează cel puțin un fundal care te descrie. Ajută doar clasamentul — nu ascunde pe nimeni.",
    "hintAccepted": "Bifează la ce ești deschis la un partener sau „Deschis — fără preferință”."
  },
  "interests": {
    "eyebrow": "Matching · Interese",
    "title": "Ce îți place",
    "text": "Alege cel puțin unul. Suprapunerea ajută clasamentul; tăcerea nu e pedepsită niciodată.",
    "hint": "Bifează cel puțin un interes."
  },
  "reflection": {
    "eyebrow": "Matching · Reflecție",
    "title": "Cu propriile tale cuvinte",
    "text": "Aceste patru răspunsuri sunt afișate integral și nu sunt niciodată punctate. Scrie ce e adevărat.",
    "describeYourself": "Descrie-te",
    "lifePurpose": "Scopul vieții",
    "fifteenYear": "Tu și dragostea vieții tale peste 15 ani",
    "weaknesses": "Slăbiciuni",
    "hintDescribe": "Descrie-te în cel puțin {min} caractere.",
    "hintPurpose": "Scrie scopul vieții tale în cel puțin {min} caractere.",
    "hintVision": "Scrie viziunea pe 15 ani în cel puțin {min} caractere.",
    "hintWeaknesses": "Numește o slăbiciune în cel puțin {min} caractere."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Câteva esențiale",
    "text": "Ține-o simplu. Sexul e binar aici — bărbat sau femeie — pentru matching clar.",
    "firstName": "Prenume",
    "firstNamePlaceholder": "Așa cum vrei să fii cunoscut",
    "age": "Vârstă",
    "agePlaceholder": "18+",
    "city": "Oraș",
    "cityPlaceholder": "Unde ești bazat",
    "sex": "Sex",
    "maleBody": "Sunt bărbat.",
    "femaleBody": "Sunt femeie.",
    "hintName": "Tastează prenumele (cel puțin două litere).",
    "hintAge": "Vârsta trebuie să fie 18 sau mai mult.",
    "hintCity": "Tastează orașul în care locuiești.",
    "hintGender": "Alege Bărbat sau Femeie ca matching-ul să funcționeze."
  },
  "ready": {
    "title": "Poți intra.",
    "textNamed": "{name}, verificarea și configurarea ta sunt înregistrate. Media e pending_review. Bun venit la UN8 — găsește-ți persoana, apoi șterge aplicația.",
    "text": "Verificarea și configurarea ta sunt înregistrate. Media e pending_review. Bun venit la UN8 — găsește-ți persoana, apoi șterge aplicația.",
    "summaryAria": "Rezumat configurare",
    "christianRules": "Creștin · reguli afirmate",
    "mediaLine": "Act · video · {photoCount} fotografii · coadă {pending}",
    "scalesLine": "Scale L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sex —",
    "professionFallback": "profesie",
    "userLine": "Utilizator {userId}",
    "enterMatching": "Intră în matching",
    "needGender": "Revino la pasul de profil și alege Bărbat sau Femeie, apoi încearcă din nou."
  },
  "match": {
    "brandTag": "Matching",
    "navOnboarding": "Onboarding",
    "navReview": "Verificare",
    "navMatching": "Matching",
    "logOut": "Deconectare",
    "enterTitle": "Intră în matching",
    "enterText": "Autentifică-te cu același email din onboarding. Cererea, pool-ul, like-urile și match-urile folosesc toate user id-ul tău stabil.",
    "email": "Email",
    "emailPlaceholder": "you@example.com",
    "password": "Parolă",
    "passwordPlaceholder": "Parola ta",
    "logIn": "Autentificare",
    "guestOr": "Sau încearcă o sesiune guest (id stabil per browser · doar demo)",
    "guestMan": "Guest ca bărbat",
    "guestWoman": "Guest ca femeie",
    "goOnboarding": "Mergi la onboarding →",
    "guestSession": "Sesiune guest · demo pool",
    "packTitle": "Cei patru ai tăi",
    "packSkip": "Atinge pentru a continua",
    "newSelection": "Selecție nouă",
    "backToFour": "← Înapoi la cei patru",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "bărbat",
    "woman": "femeie",
    "navSelection": "Selecție",
    "navMessages": "Mesaje",
    "navProfile": "Profil",
    "tabToday": "Selecție",
    "tabMatches": "Match-uri ({count})",
    "yourMatches": "Match-urile tale",
    "matchesSub": "Interes mutual persistent · {count} {likesWord} de ieșire",
    "like": "like",
    "likes": "like-uri",
    "emptyMatches": "Încă nu există interes reciproc. Continuă să discerni selecția din această săptămână.",
    "valuesScore": "Valori {score}",
    "chatOpen": " · Chat deschis",
    "tapToChat": " · Atinge pentru chat",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Valori {score}",
    "noProfileYet": "Niciun profil încă",
    "noProfileText": "Finalizează onboarding-ul sau atinge Onboarding sus, apoi Începe. Matching-ul guest e pe ecranul de intrare dacă vrei doar să te uiți.",
    "matchingPaused": "Matching în pauză",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Nimeni de arătat încă",
    "todaysSetDone": "Aceasta este selecția din această săptămână",
    "weeklyTitle": "Cei 4 ai tăi din această săptămână",
    "weeklyTitleCount": "Cei {count} ai tăi din această săptămână",
    "weeklyCountdown": "Următoarea selecție în {days} zile",
    "weeklyCountdownOne": "Următoarea selecție în 1 zi",
    "weeklyCountdownSoon": "Următoarea selecție în curând",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Aceasta este selecția din această săptămână",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Nu este nimeni încă pe lista din această săptămână. Grupul se umple — deschide Selecție din nou imediat, sau revino când vor fi aprobați mai mulți membri.",
    "emptyDone": "Ai parcurs selecția din această săptămână. Revino la următoarea deschidere sau resetează pachetul.",
    "likesMayNotStick": " Like-urile s-ar putea să nu rămână.",
    "poolMeta": "Pool: {pool} · Match-uri: {matches} · Liked: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Resetează pachetul",
    "backOnboarding": "Înapoi la onboarding",
    "feedEyebrowDemo": "Selecția săptămânii · Demo",
    "feedEyebrowLive": "Selecția săptămânii · Pool ({source}, {count})",
    "feedTitle": "Discerne cu grijă",
    "left": "mai sunt {count}",
    "pass": "Treci",
    "interested": "Interesat",
    "swipeHint": "Swipe sau folosește butoanele. Un match se deschide doar când interesul e mutual și salvat.",
    "celebrationEyebrow": "Interes mutual",
    "celebrationTitle": "Ați făcut match",
    "celebrationText": "{self} și {other} au arătat amândoi interes. Aliniere valori: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chat-ul e deblocat pentru acest match. Păstrează-l respectuos — legământ peste comoditate.",
    "openChat": "Deschide chat",
    "keepDiscerning": "Continuă discernământul",
    "cardSeeking": "Caută",
    "cardHobbies": "Hobby-uri",
    "affinity": "Afinitate",
    "valuesScoreLabel": "Scor de valori",
    "scoreStrong": "Aliniere puternică",
    "scoreSolid": "Aliniere solidă",
    "scoreModerate": "Aliniere moderată",
    "scoreDifferent": "Ritmuri diferite",
    "characterAxisFoot": "Axa de caracter include cei patru piloni",
    "youThem": "Tu {self} · Ei {other}",
    "stampInterest": "Interes",
    "stampPass": "Treci",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Scorurile voastre de valori stau aproape ({score} din 100).",
    "explainLegacyFuller": "Un „de ce” mai complet apare după ce amândoi terminați întrebările de matching.",
    "explainFaith": "Intensitatea credinței voastre e apropiată — luați urmarea lui Isus cu seriozitate similară.",
    "explainCharacter": "Cum tratați oamenii acasă se aliniază — pace, maniere și grijă.",
    "explainPurpose": "V-ați evaluat onestitatea similar, ceea ce e un semn de seriozitate comună.",
    "explainHome": "Împărtășiți un interes pentru pământ, cultivarea hranei sau o casă autosuficientă.",
    "explainAncestry": "Amândoi preferați fundaluri familiale similare. E o preferință, nu un filtru — nimeni nu e ascuns pentru asta.",
    "explainTemperament": "Interesele și temperamentul vostru se suprapun.",
    "explainFallback": "Există un posibil match pe răspunsurile pe care le-ați completat amândoi.",
    "explainOverall": "Afinitate generală {score} din 100.",
    "affinityAxes": {
      "faith": "Intensitatea credinței",
      "character": "Caracter și conduită",
      "purpose": "Alinierea scopului vieții",
      "home": "Casă și autosuficiență",
      "ancestry": "Afinitate culturală și de fundal",
      "temperament": "Potrivire de temperament"
    },
    "scaleAxes": {
      "loyalty": "Loialitate",
      "honesty": "Onestitate",
      "passion": "Pasiune",
      "commitment": "Angajament"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chat",
    "unavailableTitle": "Chat indisponibil",
    "unavailableText": "Acest match lipsește sau nu aparține sesiunii tale.",
    "backToMatches": "Înapoi la match-uri",
    "backMatches": "← Match-uri",
    "valuesSubscriber": "Valori {score} · Abonat",
    "valuesTrial": "Valori {score} · Probă",
    "valuesKept": "Valori {score} · Match păstrat",
    "empty": "Spune bună ziua cu grijă. Pe backend-ul comun, mesajele se sincronizează pe ambele telefoane după un match mutual.",
    "placeholder": "Mesaj pentru {name}…",
    "ariaMessage": "Mesaj",
    "send": "Trimite"
  },
  "billing": {
    "paywallCopy": "După proba gratuită, păstrezi pe toți cu care ai făcut deja match și continui chat-ul. Ca să vezi oameni noi, abonează-te.",
    "signInToMatch": "Autentifică-te ca să folosești matching-ul.",
    "signInFirst": "Autentifică-te mai întâi.",
    "subscriberUntil": "Abonat · până la {date}",
    "renewal": "reînnoire",
    "freeTrial": "Probă gratuită · {days} zile (se termină {date})",
    "soon": "în curând",
    "trialEnded": "Proba s-a terminat · match-urile și chat-ul rămân deschise",
    "subscribe": "Abonează-te · ${price}/lună",
    "subscribeEarly": "Abonează-te mai devreme · ${price}/lună",
    "activeNote": "Abonament activ — poți vedea din nou oameni noi.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Salvează codul de recuperare",
    "recoveryText": "Notează-l acum. E afișat o singură dată. Dacă îți pierzi parola, acest cod e singura cale de a o reseta în testul închis.",
    "savedContinue": "L-am salvat — continuă",
    "welcomeBack": "Bine ai revenit",
    "createAccount": "Creează-ți contul",
    "intro": "Handle și parolă. Nu se trimite email sau SMS. Id-ul tău rămâne stabil în onboarding, verificare și matching.",
    "tabLogin": "Autentificare",
    "tabRegister": "Înregistrare",
    "handle": "Handle",
    "handlePlaceholder": "you@example.com sau un handle scurt",
    "passphrase": "Parolă",
    "passphrasePlaceholder": "Cel puțin 8 caractere",
    "submitLogin": "Autentificare",
    "submitRegister": "Creează cont",
    "backWelcome": "Înapoi la bun venit"
  },
  "options": {
    "origin": {
      "african": "African",
      "european": "European",
      "asian": "Asiatic",
      "latino": "Latino / Hispanic",
      "middleEastern": "Orientul Mijlociu",
      "indigenous": "Indigen",
      "mixed": "Mixt",
      "other": "Altul",
      "dutch": "Olandez",
      "german": "German",
      "any": "Deschis — fără preferință"
    },
    "interest": {
      "prayer": "Rugăciune",
      "worship": "Închinare",
      "reading": "Lectură",
      "hiking": "Drumeții",
      "music": "Muzică",
      "cooking": "Gătit",
      "farming": "Agricultură / grădinărit",
      "sports": "Sport",
      "missions": "Misiuni",
      "family": "Viața de familie",
      "crafts": "Meșteșuguri",
      "outdoors": "În aer liber"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Da",
      "no": "Nu"
    },
    "id": {
      "titleEmpty": "Act de identitate oficial",
      "titleReady": "Act gata",
      "hintEmpty": "Pașaport sau carte de identitate națională. Fă o fotografie live sau alege o imagine/PDF. Toate cele patru colțuri vizibile.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · salvat",
      "previewAlt": "Previzualizare act de identitate",
      "pdfAria": "Document PDF selectat",
      "takePhoto": "Fă o fotografie",
      "retake": "Refă",
      "chooseFile": "Alege fișier",
      "replaceFile": "Înlocuiește fișierul",
      "remove": "Elimină",
      "uploading": "Se încarcă…",
      "cameraTitle": "Fotografiază actul de identitate",
      "signIn": "Autentifică-te înainte de a încărca actul de identitate.",
      "uploadFailed": "Încărcarea a eșuat. Încearcă din nou.",
      "badFile": "Nu s-a putut folosi acest fișier."
    },
    "video": {
      "titleEmpty": "Videoclip de confirmare",
      "titleLive": "Cameră live",
      "titleReady": "Videoclip gata",
      "hintEmpty": "Spune-ți prenumele și că te alături UN8 onest. 5–15 secunde.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Înregistrează",
      "cameraUpload": "Încărcare cameră",
      "chooseFile": "Alege fișier",
      "startRecording": "Începe înregistrarea",
      "cancel": "Anulează",
      "stopSave": "Oprește și salvează",
      "recordAgain": "Înregistrează din nou",
      "replaceFile": "Înlocuiește fișierul",
      "remove": "Elimină",
      "unsupported": "Înregistrarea live nu e disponibilă aici. Folosește încărcarea din cameră sau alege un fișier.",
      "permissionDenied": "Permisiunea camerei a fost refuzată. Poți totuși încărca un fișier video scurt.",
      "signIn": "Autentifică-te înainte de a încărca videoclipul.",
      "uploadFailed": "Încărcarea a eșuat. Încearcă din nou.",
      "saveFailed": "Nu s-a putut salva înregistrarea.",
      "badVideo": "Nu s-a putut folosi acest videoclip."
    },
    "photos": {
      "count": "{count} / {max} fotografii",
      "minimumMet": "Minim atins",
      "moreRequired": "Mai sunt necesare {n}",
      "listAria": "Fotografii de verificare",
      "photoAlt": "Fotografie {n}",
      "removeAria": "Elimină fotografia {n}",
      "camera": "Cameră",
      "takePhoto": "Fă o fotografie",
      "chooseFiles": "Alege fișiere",
      "uploading": "Se încarcă…",
      "hint": "Fă o fotografie deschide camera live. Alege fișiere e doar pentru selecții din galerie. Cadre clare cu fața — fără filtre care ascund identitatea. Max {max}.",
      "cameraTitle": "Fă o fotografie cu tine",
      "signIn": "Autentifică-te înainte de a încărca fotografiile.",
      "someFailed": "Unele fotografii nu s-au putut încărca. Reîncearcă pe cele eșuate.",
      "addFailed": "Nu s-au putut adăuga fotografii."
    },
    "liveStill": {
      "titleDefault": "Cameră",
      "close": "Închide",
      "capture": "Capturează",
      "cancel": "Anulează",
      "hint": "Ține stabil. Camera live rămâne deschisă până capturezi.",
      "unavailable": "Camera nu e disponibilă în acest browser. Folosește Alege fișier în schimb.",
      "permissionDenied": "Permisiunea camerei a fost refuzată sau indisponibilă. Folosește Alege fișier în schimb.",
      "frameFailed": "Nu s-a putut captura acest cadru.",
      "saveFailed": "Nu s-a putut salva fotografia."
    },
    "uploadStatus": {
      "uploading": "se încarcă…",
      "failed": "încărcare eșuată",
      "savedLocally": "salvat local",
      "uploaded": "încărcat",
      "stored": "stocat",
      "awaitingUpload": "Așteaptă încărcarea",
      "localFallbackNote": "{error} Fișierul e salvat pe acest dispozitiv; reîncearcă când sign endpoint-ul e disponibil."
    }
  },
  "language": {
    "label": "Limbă",
    "choose": "Alege limba"
  },
  "shell": {
    "back": "Înapoi",
    "goBackAria": "Înapoi"
  }
} as Messages;
